 /**
 * Created by anthony on 10/14/14.
 */

var tabs = angular.module('tabs', ['classy', 'applicationOverview', 'awardCalculation', 'awardData', 'historyModule']);
tabs.classy.controller({
    name: 'TabsController',
    inject: ['$scope', '$http', 'BinFactory', '$location', '$anchorScroll', 
    'authServiceFactory', 'BinSummaryService', 'TabsService', 'CommitteeModeModelService', 'SliderService' ],
    init: function ()
    {
        this.$.TabsService = this.TabsService;
    }

});

tabs.service('TabsService', function($rootScope, PermissionModelService, SliderService, SliderFactory, authServiceFactory)
{
    this.businessIncomeOpen = false;
    this.allowancesOpen = false;
    this.assetsOpen = false;
    this.liabilitiesOpen = false;
    this.fromCalc = false;

    this.activeIndex = 0;
    this.newTabs = [];

    var index = 0;
    
    this.newTabs[index] = {};
    this.newTabs[index].title = "Data";
    this.newTabs[index].active = true;
    this.newTabs[index].url = "fast/submodules/schoolside/applications/submodules/tabs/submodules/awardData/partials/awardData.html?v=" + versionNo;
    this.newTabs[index].disabled = false;
    index++;

    var taxTab = authServiceFactory.getAuth().permissions.taxTab;

    this.newTabs[index] = {};
    this.newTabs[index].title = "History";
    this.newTabs[index].active = false;
    this.newTabs[index].url = "fast/submodules/schoolside/applications/submodules/tabs/submodules/history/partials/history.html?v=" + versionNo;
    this.newTabs[index].disabled = false;
    index++;

    this.newTabs[index] = {};
    this.newTabs[index].title = "Calculation";
    this.newTabs[index].active = false;
    this.newTabs[index].url = "fast/submodules/schoolside/applications/submodules/tabs/submodules/awardCalculation/partials/awardCalculation.html?v=" + versionNo;
    this.newTabs[index].disabled = false;
    index++;

    this.newTabs[index] = {};
    this.newTabs[index].title = "Edit";
    this.newTabs[index].active = false;
    this.newTabs[index].url = "fast/submodules/schoolside/applications/submodules/tabs/submodules/edit/partials/edit.html?v=" + versionNo;
    this.newTabs[index].disabled = false;
    index++;





    this.setActiveTab =  function(div)
    {

        var parent = this;
        var index = 0;
        if (isNaN(div))
        {
            if (div == "awardData")
                index = 0;
            else if (div == "taxes")
                index = 1;
            else if (div == "history")
                index = 2;
            else if (div == "awardCalculation")
                index = 3;
        }
        else
            index = div;


        this.newTabs[this.activeIndex].active = false;
        this.newTabs[index].active = true;
        this.activeIndex = index;
        this.businessIncomeOpen = false;
    }

    this.setActiveDiv = function(div)
    {
        this.activeDiv = div;
    }
    this.getActiveDiv = function()
    {
        return this.activeDiv;
    }
    this.setLiabilitiesOpen = function (value)
    {
        if (value==true) {
            this.fromCalc = true;
            SliderService.pushSlider(new SliderFactory('tabs/submodules/awardCalculation/partials/liabilities', 'Liabilities', 's'));
            //SliderService.setPartial('tabs/submodules/awardCalculation/partials/liabilities', 'Liabilities', 's');
        }
        else {
            this.fromCalc = false;
            SliderService.pushSlider(new SliderFactory('tabs/submodules/awardCalculation/partials/imputedIncome', 'Imputed Income', 's'));
            //SliderService.setPartial('tabs/submodules/awardCalculation/partials/imputedIncome', 'Imputed Income', 's');
        }
        this.liabilitiesOpen = value;
    }
    this.setAssetsOpen = function (value)
    {
        if (value==true) {
            this.fromCalc = true;
            SliderService.pushSlider(new SliderFactory('tabs/submodules/awardCalculation/partials/assets', 'Assets', 's'));
            //SliderService.setPartial('tabs/submodules/awardCalculation/partials/assets', 'Assets', 's');
        }
        else {
            this.fromCalc = false;
            SliderService.pushSlider(new SliderFactory('tabs/submodules/awardCalculation/partials/imputedIncome', 'Imputed Income', 's'));
            //SliderService.setPartial('tabs/submodules/awardCalculation/partials/imputedIncome', 'Imputed Income', 's');
        }
        this.assetsOpen = value;
    }
    this.setBusinessIncomeOpen = function (value)
    {
        if (value==true) 
            SliderService.pushSlider(new SliderFactory('tabs/submodules/awardCalculation/partials/businessIncome', 'Business Income', 's'));
            //SliderService.setPartial('tabs/submodules/awardCalculation/partials/businessIncome', 'Business Income', 's');
        else
            SliderService.pushSlider(new SliderFactory('tabs/submodules/awardCalculation/partials/reportedIncome', 'Reported Income', 's'));
            //SliderService.setPartial('tabs/submodules/awardCalculation/partials/reportedIncome', 'Reported Income', 's');
        this.businessIncomeOpen = false;
    }
    this.setAddedAllowancesOpen = function (value)
    {
        if (value==true) 
            SliderService.pushSlider(new SliderFactory('tabs/submodules/awardCalculation/partials/addedAllowances', 'Added Allowances', 's'));
            //SliderService.setPartial('tabs/submodules/awardCalculation/partials/addedAllowances', 'Added Allowances', 's');
        else
            SliderService.pushSlider(new SliderFactory('tabs/submodules/awardCalculation/partials/livingAllowance', 'Living Allowance', 's'));
            //SliderService.setPartial('tabs/submodules/awardCalculation/partials/livingAllowance', 'Living Allowance', 's');
        this.allowancesOpen = value;
    }
    this.setLivingAllowanceApplicantsOpen = function (value)
    {
        if (value==true) 
            SliderService.pushSlider(new SliderFactory('tabs/submodules/awardCalculation/partials/applicants', 'Applicants', 's'));
            //SliderService.setPartial('tabs/submodules/awardCalculation/partials/addedAllowances', 'Added Allowances', 's');
        else
            SliderService.pushSlider(new SliderFactory('tabs/submodules/awardCalculation/partials/livingAllowance', 'Living Allowance', 's'));
            //SliderService.setPartial('tabs/submodules/awardCalculation/partials/livingAllowance', 'Living Allowance', 's');
        this.allowancesOpen = value;
    }
    return this;


});